export const base64ToByteArray = (base64string: string) => {
    const byteString = window.atob(base64string);

    const stringBuffer = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(stringBuffer);

    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    return ia;
};

export const dataURItoByteArray = (dataURI: string) => {
    try {
        return base64ToByteArray(dataURI.split(',')?.[1]);
    } catch {
        return null;
    }
};
